import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var salesDetailRoute = [{
  path: "sales-detail/:status/:orderNumber",
  name: "salesDetail",
  component: function component() {
    return import( /* webpackChunkName: "login" */"./sales-detail.vue");
  }
}];